import { Link, router } from '@inertiajs/react'
import { useState } from 'react'
import { formatPrice } from '../utils/formatters'
import BasketModal from './BasketModal'
import NotesModal from './NotesModal'

export default function Header({
  account,
  basketTotal,
  basketCount,
  currentTab,
  basket,
  basketItems,
  menuItems = [],
  onUpdateQuantity,
  onCheckout,
  isDevelopment,
  customerNotes = '',
  onNotesChange
}) {
  const [showModal, setShowModal] = useState(false)
  const [showNotesModal, setShowNotesModal] = useState(false)
  const hasNotes = customerNotes.trim().length > 0

  const handleClearBasket = () => {
    if (confirm('Clear basket? This will remove all items.')) {
      router.post(`/${account.slug}/order/clear-basket`, {}, {
        preserveState: false
      })
    }
  }

  const backConfig = {
    food: { label: 'Back', href: `/${account.slug}/order` },
    drinks: { label: 'Food', href: `/${account.slug}/order/food` }
  }

  const titles = {
    food: 'Food',
    drinks: 'Drinks'
  }

  const back = backConfig[currentTab]
  const title = titles[currentTab]

  return (
    <>
      <nav className="sticky top-0 z-40 bg-sky-900 text-white px-1 py-2" aria-label={`${title} menu navigation`}>
        <div className="flex items-center justify-between relative">
          <Link
            href={back.href}
            className="text-white hover:text-white/80 flex items-center gap-1 min-w-[60px] focus:outline-none focus:ring-2 focus:ring-white rounded px-1 py-1"
            aria-label={`Go back to ${back.label}`}
          >
            <span aria-hidden="true">←</span> {back.label}
          </Link>

          <h1 className="absolute left-1/2 -translate-x-1/2 max-w-[40%] truncate text-lg font-bold">{title}</h1>

          <div className="flex items-center gap-2">
            {/* Notes button */}
            <button
              onClick={() => setShowNotesModal(true)}
              className={`flex items-center justify-center w-10 h-10 rounded-lg text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 ${
                hasNotes
                  ? 'bg-sky-100 text-sky-900 hover:bg-sky-200'
                  : 'bg-white/20 text-white hover:bg-white/30'
              }`}
              aria-label={hasNotes ? 'Edit note' : 'Add note'}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>

            {/* Basket button */}
            <button
              onClick={() => setShowModal(true)}
              className="flex items-center gap-0.5 bg-white text-sky-900 px-2 py-2 rounded-lg text-sm font-medium hover:bg-gray-100 transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
              aria-label={`View basket, ${basketCount} ${basketCount === 1 ? 'item' : 'items'}, ${formatPrice(basketTotal)}`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
              <span aria-hidden="true">{formatPrice(basketTotal)}</span>
              {basketCount > 0 && (
                <span aria-hidden="true">({basketCount})</span>
              )}
            </button>
          </div>
        </div>
      </nav>

      {showModal && (
        <BasketModal
          basket={basket}
          basketItems={basketItems}
          menuItems={menuItems}
          onClose={() => setShowModal(false)}
          onUpdateQuantity={onUpdateQuantity}
          onCheckout={() => {
            setShowModal(false)
            onCheckout()
          }}
        />
      )}

      {showNotesModal && (
        <NotesModal
          notes={customerNotes}
          onSave={onNotesChange}
          onClose={() => setShowNotesModal(false)}
        />
      )}
    </>
  )
}
